import { c as _c } from "react/compiler-runtime";
import { FlexColumn, Separator, Table } from "@opensea/ui-kit";
import { CollectionSweepQuoteReceiptSummary } from "./CollectionSweepQuoteReceiptSummary";
import { CollectionSweepQuoteReceiptTotal } from "./CollectionSweepQuoteReceiptTotal";
export const CollectionSweepQuoteReceipt = props => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props) {
    t0 = <Table itemKey={_temp} items={[props]} renderRow={_temp2} size="xl" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Separator className="mt-2" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <Table itemKey={_temp3} items={[props]} renderRow={_temp4} />;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t2) {
    t3 = <FlexColumn className="w-full">{t0}{t1}{t2}</FlexColumn>;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function _temp(_, index) {
  return index;
}
function _temp2(props_0) {
  return <CollectionSweepQuoteReceiptSummary {...props_0.item} />;
}
function _temp3(__0, index_0) {
  return index_0;
}
function _temp4(props_1) {
  return <CollectionSweepQuoteReceiptTotal {...props_1.item} />;
}